import React, { useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import BaseSelect from 'components/baseSelect';
import { Field } from 'formik';

const SolicitudEmpleo = ({errors, touched, handleChange, values, element, removePhoneNumber, options, InputMask}) => {
    const onRemovePhoneNumber = () => removePhoneNumber(element.id);

    const onChangeRadio = (event) => {
        if (event.target.value == "true") {
            values[`familia_${element.id}`] = true 
        } else {
            values[`familia_${element.id}`] = false
        }
    }

    const alignEnd = {
        display: 'flex',
        alignItems: 'flex-end'
    }
    
    const alignCenter = {
        display: 'flex',
        alignItems: 'center'
    }

    return (
        <>
            <Form.Group as={Col} md="4" controlId="validationFormik03">
                <Form.Label>Nombres *</Form.Label>
                <Form.Control
                    type="text"
                    name={`nombreEmpleado_${element.id}`}
                    value={values[`nombreEmpleado_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`nombreEmpleado_${element.id}`] && !errors[`nombreEmpleado_${element.id}`]}
                    isInvalid={!!errors[`nombreEmpleado_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`nombreEmpleado_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group  as={Col} md="1" id={`validation${element.id}`}>
                <div >
                    <Form.Label> <span className="esFamiliar"> ¿Es familiar? </span> </Form.Label>
                    <div onChange={onChangeRadio}>
                        <input type="radio" value="true" name={`familia_${element.id}`}  defaultChecked={values[`familia_${element.id}`]}  /> {' '}Sí
                        &nbsp;&nbsp;<input type="radio" value="false" name={`familia_${element.id}`}  defaultChecked={!values[`familia_${element.id}`]} />  {' '}No
                    </div>
                </div>
            </Form.Group>

            <BaseSelect
                md={7}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Relación *'}
                name={`parentescoId_${element.id}`}
                url={'Parentesco?$filter=Laboral eq 0'}
            />
            
            <Form.Group as={Col} md="12" style={!!errors[`phoneNumber_${element.id}`] ? alignCenter : alignEnd}>
                <Button onClick={onRemovePhoneNumber} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
            </Form.Group>
        </>
    )
}

export default SolicitudEmpleo;